import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const HouseKeepingInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="House Keeping"
    sectionKey="House Keeping"
    backRoute="/sections/house-keeping"
  />
);

export default HouseKeepingInternalTransfer;
